import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { nanoid } from "nanoid";
import Logo from "../../Logo/Logo";
import { authClient } from "../../../lib/auth-client";
import Hamburger from "../../Hamburger/Hamburger";

const Header = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { data: session } = authClient.useSession();

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const handleSignOut = async () => {
    const cacheBuster = nanoid();
    await authClient.signOut({
      fetchOptions: {
        onSuccess: () => {
          navigate("/jupiter/?c=" + cacheBuster, { replace: true });
        },
      },
    });
  };

  if (isLoading) {
    return (
      <>
        <header>
          <div className="pt-4"></div>
          <div className="flex justify-center pt-8">
            <div className="w-[220px]">
              <Logo isDark />
            </div>
          </div>
        </header>
      </>
    );
  }

  if (!session) {
    return (
      <>
        <header>
          <div className="pt-4"></div>
          <div className="flex justify-center pt-8">
            <div className="w-[220px]">
              <Logo isDark />
            </div>
          </div>
        </header>
      </>
    );
  }

  return (
    <>
      <Hamburger session={session} onSignOut={handleSignOut} />
      <header className="mb-8">
        <div className="pt-4"></div>

        <div className="flex justify-center p-4 mx-auto w-full">
          <div className="pt-3 flex-none">
            <div className="w-[220px]">
              <Logo isDark />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
